(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

module.exports = Vue.component('instagram-account',{
    props:['item','authurl'],
    methods:{},
    template:
     `<div class="vue-instagram-account">
        <p>Click Authoize to get a token. Then paste the token in the field.</p>
        <p>
            <label>Instagram Handle</label>
            <input type="text" v-model="item.handle" placeholder="@thechurchco" />
        </p>
        <p>
            <label>Instagram User ID</label>
            <input type="text" v-model="item.user_id" placeholder="12345679876" />
        </p>
        <p>
            <label>Instagram Token</label>
            <input type="text" v-model="item.token" placeholder="sdfkjhsdfsdjh38sdkjhlkndbf" />
        </p>
     </div>`
 });
 
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/vue/components/instagram-account.js","/vue/components")